var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.isCover),expression:"$store.state.isCover"}],staticClass:"cover",on:{"click":_vm.hideQRcode}})
}
var staticRenderFns = []

export { render, staticRenderFns }